
import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { UtilsService } from '@services/utils.service';
import { ApmService } from '../services/apm.service';

@Injectable()
export class ApmMaintenanceResolver implements Resolve<any> {

    constructor(
        private apmService: ApmService,
        private utilsService: UtilsService
    ) { }

    public resolve(route: ActivatedRouteSnapshot) {
        const params = { timeslotId: this.utilsService.findUpRouteParams(route, 'timeslotId')}
        return this.apmService.getTimeslot(params.timeslotId);
    }
}
